const CONTACT_METHODS = ["sms", "whats", "email"] as const;

export { CONTACT_METHODS };
